import FeedsTable from '@/feeds/FeedsTable.vue'
import SchedulesTable from '@/schedules/SchedulesTable.vue'
import GeneralTab from '@/components/flyover/tabs/GeneralTab.vue'
import SchedulesTab from '@/components/flyover/tabs/SchedulesTab.vue'
import ActivityLogTab from '@/components/flyover/tabs/ActivityLogTab.vue'
import {
  COLUMNS as columnFeeds,
  ACTIONS as actionsFeeds,
} from '@/feeds/config/constants'
import {
  COLUMNS as columnSchedules,
  ACTIONS as actionsSchedules,
} from '@/schedules/config/constants'

const CONFIG = {
  feeds: {
    component: FeedsTable,
    props: {
      columns: columnFeeds,
      actions: actionsFeeds,
    },
    flyoverTabs: [
      {
        id: 'general',
        name: 'flyover.general.tab',
        component: GeneralTab,
        isActive: true,
      },
      {
        id: 'schedules',
        name: 'flyover.feeds.schedules.tab',
        component: SchedulesTab,
        isActive: false,
      },
      {
        id: 'exportActivityLog',
        name: 'flyover.feeds.exportActivityLog.tab',
        component: ActivityLogTab,
        isActive: false,
      },
    ],
  },
  schedules: {
    component: SchedulesTable,
    props: {
      columns: columnSchedules,
      actions: actionsSchedules,
    },
    flyoverTabs: [
      {
        id: 'general',
        name: 'flyover.general.tab',
        component: GeneralTab,
        isActive: true,
      },
      {
        id: 'activityLog',
        name: 'flyover.schedules.activityLog.tab',
        component: ActivityLogTab,
        isActive: false,
      },
    ],
  },
}

export default CONFIG
